import { PublicationAttachType } from "generated/CoreApi_v1";

export function isPresentationAttach(at: PublicationAttachType) {
    return (at == PublicationAttachType.Image
        || at == PublicationAttachType.Audio
        || at == PublicationAttachType.Video
        || at == PublicationAttachType.YouTube
        || at == PublicationAttachType.Vimeo);
}
